const scripts = new Set();
export const hasVendorScripts = () => scripts.size > 0;
const addScript = (id, src) => {
    if (scripts.has(id)) return;
    scripts.add(id);
    const element = document.createElement("script");
    element.id = id; element.src = src; element.async = true; element.dataset.apfTracker = "true";
    element.onerror = () => { element.dataset.failed = "true"; };
    document.head.appendChild(element);
};
export const googleConsent = (c) => ({
    analytics_storage: c.analytics ? "granted" : "denied",
    ad_storage: c.marketing ? "granted" : "denied",
    ad_user_data: c.marketing ? "granted" : "denied",
    ad_personalization: c.marketing ? "granted" : "denied",
});
export const loadGoogle = (id, consent) => {
    if (!window.gtag) {
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () { window.dataLayer.push(arguments); };
        window.gtag("consent", "default", googleConsent({}));
        window.gtag("js", new Date());
        window.gtag("set", "ads_data_redaction", true);
    }
    window.gtag("consent", "update", googleConsent(consent));
    const url = new URL(process.env.REACT_APP_GOOGLE_TAG_URL);
    url.searchParams.set("id", id);
    addScript("apf-google-tag", url.href);
};

export const loadMeta = (id) => {
    if (scripts.has("apf-meta-pixel")) return;
    const fbq = window.fbq = function () {
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    window._fbq = fbq; fbq.push = fbq; fbq.loaded = true; fbq.version = "2.0"; fbq.queue = [];
    fbq("consent", "revoke");
    fbq("set", "autoConfig", false, id);
    fbq("init", id);
    fbq("consent", "grant");
    addScript("apf-meta-pixel", new URL(process.env.REACT_APP_META_PIXEL_URL).href);
};

export const loadTikTok = (id) => {
    if (scripts.has("apf-tiktok-pixel")) return;
    window.TiktokAnalyticsObject = "ttq";
    const ttq = window.ttq = [];
    ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"];
    ttq.setAndDefer = (target, method) => { target[method] = (...args) => target.push([method, ...args]); };
    ttq.methods.forEach((method) => ttq.setAndDefer(ttq, method));
    ttq.instance = (pixelId) => {
        const instance = ttq._i?.[pixelId] || [];
        ttq.methods.forEach((method) => ttq.setAndDefer(instance, method));
        return instance;
    };
    const url = new URL(process.env.REACT_APP_TIKTOK_PIXEL_URL);
    ttq._i = { [id]: [] }; ttq._i[id]._u = url.href;
    ttq._t = { [id]: Date.now() }; ttq._o = { [id]: {} };
    ttq.holdConsent(); ttq.disableCookie(); ttq.grantConsent(); ttq.enableCookie();
    url.searchParams.set("sdkid", id); url.searchParams.set("lib", "ttq");
    addScript("apf-tiktok-pixel", url.href);
};